import React from "react";

import { useIntl } from "react-intl";

import Price from "@mapmycustomers/shared/types/plans/Price";
import { Button } from "@mapmycustomers/ui";

import formatPrice from "../../util/formatPrice";

interface Props {
  disabled?: boolean;
  loading?: boolean;
  onCloseClick?: () => void;
  onPayClick?: () => void;
  price: Price;
  success?: boolean;
}

const Footer: React.FC<Props> = ({
  disabled,
  loading,
  onCloseClick,
  onPayClick,
  price,
  success,
}) => {
  const intl = useIntl();
  return success ? (
    <Button block onClick={onCloseClick} type="primary">
      {intl.formatMessage({
        id: "billing.checkout.return",
        defaultMessage: "Return to Map My Customers",
        description: "Return to MMC button in Checkout modal on Billing page",
      })}
    </Button>
  ) : (
    <Button disabled={disabled || loading} loading={loading} onClick={onPayClick} type="text">
      {intl.formatMessage(
        {
          id: "billing.checkout.pay",
          defaultMessage: "Pay {price}",
          description: "Pay button in Checkout modal on Billing page",
        },
        { price: formatPrice(intl, price, 2) }
      )}
    </Button>
  );
};

export default Footer;
